import Vuex from 'vuex';
import tankAbandonment from './modules/tankAbandonment'
import energySystems from './modules/energySystems'
import manyUnloadingForFuel from './modules/manyUnloadingForFuel'
import manyUnloadingForPellets from './modules/manyUnloadingForPellets'
import manyUnloadingForServices from './modules/manyUnloadingForServices'
import contact from './modules/contact'
import newsletterSubscription from './modules/newsletterSubscription'
import newsletterUnsubscription from './modules/newsletterUnsubscription'
import competitionParticipation from './modules/competitionParticipation'
import genericInteraktionsformular from './modules/genericInteraktionsformular'
import eMobilityServices from './modules/eMobilityServices'
import energyForum from './modules/energyForum'
import lastTankBoilerCheck from './modules/lastTankBoilerCheck'
import sweepstake from './modules/sweepstake'
import eMobilityServicesSmall from './modules/eMobilityServicesSmall'
import migrolcardCompanyCard from './modules/migrolcardCompanyCard'

import $ from 'jQuery';

// state
function createState(settings, strings, enums, images) {
    var res = {
        //server-side settings
        Strings: strings,
        Enums: enums,
        Images: images,
        FormType: settings.FormType,
        ProductType: settings.ProductType,
        AvailableDeliveryPeriods: settings.DeliveryPeriods,
        AjaxCallsPending: 0,
        ServerErrormessages: [],
        GoalId: settings.GoalId,
        NLSubLink: settings.NLSubLink,
        CliendId: settings.ClientID,
        IsClientKnown: settings.IsClientKnown && (settings.FormType == 'NewsletterUnsubscription' || settings.FormType == 'NewsletterSubscription'), //note: we only use this for the newsletter an/abmeldung ATM
        SubjectOverride: settings.SubjectOverride,

        //address fields:        
        salutation: '',
        firstName: '',
        lastName: '',
        companyName: '',
        street: '',
        streetNumber: '',
        addressLine2: '',
        zipcode: '',
        city: '',
        countryCode: '',
        phone: '',
        emailAddress: '',
        mlGuid: null,

        //generic form fields
        comments: '',
        dseAccepted: false
    }
    if (settings.PrefillAddress) {
        res.salutation = settings.PrefillAddress.salutation;
        res.firstName = settings.PrefillAddress.firstName;
        res.lastName = settings.PrefillAddress.lastName;
        res.companyName = settings.PrefillAddress.companyName;
        res.street = settings.PrefillAddress.street;
        res.streetNumber = settings.PrefillAddress.streetNumber;
        res.addressLine2 = settings.PrefillAddress.addressLine2;
        res.zipcode = settings.PrefillAddress.zipcode;
        res.city = settings.PrefillAddress.city;
        res.countryCode = settings.PrefillAddress.countryCode;
        res.phone = settings.PrefillAddress.phone;
        res.emailAddress = settings.PrefillAddress.emailAddress;
        res.mlGuid = settings.PrefillAddress.mlGuid;
    }
    return res;
}

// getters
const getters = {
    // converts the address fields to an object to send to the forms api
    baseData: state => {
        var result = {
            comments: state.comments,
            //WWW-2163: no longer submit dseAccepted
            //dseAccepted: state.dseAccepted,
            ProductType: state.ProductType,
            clientId: state.CliendId,
            isClientKnown: state.IsClientKnown,
            subjectOverride: state.SubjectOverride,
        };
        if (!state.IsClientKnown) {
            result.address = {
                salutation: state.salutation,
                firstName: state.firstName,
                lastName: state.lastName,
                companyName: state.companyName,
                street: state.street,
                streetNumber: state.streetNumber,
                addressLine2: state.addressLine2,
                zipcode: state.zipcode,
                city: state.city,
                countryCode: state.countryCode,
                phone: state.phone,
                emailAddress: state.emailAddress,
                mlGuid: state.mlGuid
            };
        }
        return result;
    },
    isWaitingForAjax: state => {
        return state.AjaxCallsPending > 0;
    }
}

// actions
const actions = {
    async TriggerGoal({ state }) {
        if (state.GoalId && state.GoalId != '') {
            $.post('/migrolapi/tracking/TriggerGoal', { GoalId: state.GoalId });
        }
    }
}

// mutations
const mutations = {
    // address fields
    setAddress(state, newAddress) {
        state.salutation = newAddress.salutation;
        state.firstName = newAddress.firstName;
        state.lastName = newAddress.lastName;
        state.companyName = newAddress.companyName;
        state.street = newAddress.street;
        state.streetNumber = newAddress.streetNumber;
        state.addressLine2 = newAddress.addressLine2;
        state.zipcode = newAddress.zipcode;
        state.city = newAddress.city;
        state.countryCode = newAddress.countryCode;
        state.phone = newAddress.phone;
        state.emailAddress = newAddress.emailAddress;
    },

    // generic form fields
    setComments(state, newValue) {
        state.comments = newValue;
    },
    setDseAccepted(state, newValue) {
        state.dseAccepted = newValue;
    },
    increasePendingAjaxCalls(state) {
        state.AjaxCallsPending++;
    },
    decreasePendingAjaxCalls(state) {
        state.AjaxCallsPending--;
    },
    addServerErrormessages(state, newMessages) {
        if (newMessages !== null && newMessages.length > 0) {
            state.ServerErrormessages = state.ServerErrormessages.concat(newMessages);
        }
    },
    clearServerErrormessages(state) {
        state.ServerErrormessages = [];
    }
}

export default function createStore(settings, strings, enums, images) {

    let store = new Vuex.Store({
        state: createState(settings, strings, enums, images),
        getters,
        actions,
        mutations,
        modules: createModules(settings),
        strict: true
    });

    //init email permissions
    if (settings.FormType == 'NewsletterUnsubscription' && settings.ClientID) {
        $.get('/migrolapi/' + window.CONFIG.language + '/forms/GetEmailPermissions?clientId=' + settings.ClientID).then(function (response) {
            store.commit('newsletterUnsubscription/setChannelTotal', response.total);
            store.commit('newsletterUnsubscription/setChannelFuel', response.fuel);
            store.commit('newsletterUnsubscription/setChannelEnergy', response.energy);
            store.commit('newsletterUnsubscription/setChannelServices', response.services);
            store.commit('newsletterUnsubscription/setChannelPellets', response.pellets);
            store.commit('newsletterUnsubscription/setChannelDiesel', response.diesel);
            store.commit('newsletterUnsubscription/setChannelInfo', response.info);
        }, function (error) {
            console.error(error);
        });
    }

    //init competition participation
    if (settings.FormType == 'CompetitionParticipation') {
        store.commit('competitionParticipation/setCompetitionName', settings.CompetitionName);
    }

    //init generic interaktionsformular
    if (settings.FormType == 'GenericInteraktionsformular') {
        store.commit('genericInteraktionsformular/setIFTitle', settings.GenericIFSettings.Title);
        store.commit('genericInteraktionsformular/setIFType', settings.GenericIFSettings.Type);
        store.commit('genericInteraktionsformular/setIFActivityGroup', settings.GenericIFSettings.ActivityGroup);
    }

    //init preselected product interests (atm only for NL subscription)
    if (settings.FormType == 'NewsletterSubscription') {
        store.commit('newsletterSubscription/setProductInterests', settings.PreselectedProductInterests);
    }

    return store;
}

function createModules(settings) {

    switch (settings.FormType) {
        case 'TankAbandonment':
            return { tankAbandonment }
        case 'EnergySystems':
            return { energySystems }
        case 'ManyUnloadingForFuel':
            manyUnloadingForFuel.state.productType = settings.ProductType;
            return { manyUnloadingForFuel }
        case 'ManyUnloadingForPellets':
            return { manyUnloadingForPellets }
        case 'ManyUnloadingForServices':
            return { manyUnloadingForServices }
        case 'Contact':
            return { contact }
        case 'NewsletterSubscription':
            return { newsletterSubscription }
        case 'NewsletterUnsubscription':
            return { newsletterUnsubscription }
        case 'CompetitionParticipation':
            return { competitionParticipation }
        case 'GenericInteraktionsformular':
            return { genericInteraktionsformular }
        case 'EMobilityServices':
            return { eMobilityServices }
        case 'EMobilityServicesSmall':
            return { eMobilityServicesSmall }
        case 'EnergyForum':
            return { energyForum }
        case 'LastTankBoilerCheck':
            return { lastTankBoilerCheck }
        case 'Sweepstake':
            return { sweepstake }
        case 'MigrolcardCompanyCard':
            return { migrolcardCompanyCard }
    }

    return {};
}
